import { render, staticRenderFns } from "./richtext_editor.vue?vue&type=template&id=19252fb1&lang=pug"
import script from "./richtext_editor.vue?vue&type=script&lang=js"
export * from "./richtext_editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports